import React from 'react';
import './LoadingPage.css';
const logo = process.env.PUBLIC_URL + '/logo.png';

const LoadingPage: React.FC = () => {
  return (
    <div className="loading-page">
      <img src={logo} alt="Arrank! Logo" className="loading-logo" />
      <div className="loading-spinner">
        <svg width="60" height="60" viewBox="0 0 60 60">
          <circle
            cx="30"
            cy="30"
            r="26"
            stroke="#10b981"
            strokeWidth="6"
            fill="none"
            strokeDasharray="40 100"
            strokeLinecap="round"
          >
            <animateTransform
              attributeName="transform"
              type="rotate"
              from="0 30 30"
              to="360 30 30"
              dur="1s"
              repeatCount="indefinite"
            />
          </circle>
        </svg>
      </div>
    </div>
  );
};

export default LoadingPage;
